import * as React from "react";
function SvgMore(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd" clipRule="evenodd" fill="currentColor"><path d="M1.744 10.744L5.487 7 1.744 3.256 2.5 2.5 7 7l-4.5 4.5-.756-.756zM7 10.744L10.744 7 7 3.256l.756-.756 4.5 4.5-4.5 4.5L7 10.744z" /></g></svg>;
}
export default SvgMore;